import { z } from "zod";
/**
 * Launch promotion: discounted first Premium upgrade on eligible plans.
 *
 * State lives at `/promos/{id}` (single live doc `launch50`). Owned by
 * Cloud Functions — clients read it for marketing/upgrade pricing; checkout
 * stamps `promoApplied` on the user after a successful discounted payment.
 */
export const PROMO_LAUNCH50_ID = "launch50";
/** Legacy yearly kind kept for historical promoApplied records. New checkouts use wedding-pass only. */
export const PromoKindSchema = z.enum(["yearly", "wedding-pass"]);
export const PromoSchema = z.object({
    /**
     * The promo id. The doc id at `/promos/{id}` is the source of truth — we
     * never persist `id` onto the document itself. Callers that need the id
     * after parsing should inject it from `snap.id` (see how the admin stats
     * query reads the doc). Marked optional so parsing raw Firestore data
     * does not require synthesising an `id` field first.
     */
    id: z.string().optional(),
    active: z.boolean(),
    discountPercent: z.number().int().min(1).max(99),
    eligibleKinds: z.array(PromoKindSchema).nonempty(),
    /**
     * End-of-promo timestamp (ISO-8601). Required for the promo to apply:
     * inactive once `Date.now() >= Date.parse(expiresAt)`.
     */
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime().optional(),
    updatedAt: z.string().datetime().optional(),
});
export const PromoAppliedSchema = z.object({
    code: z.string(),
    appliedAt: z.string().datetime(),
    discountPercent: z.number().int().min(1).max(99),
    kind: PromoKindSchema,
});
